import { render, staticRenderFns } from "./hiddenPotential.vue?vue&type=template&id=057b10d0&scoped=true"
import script from "./hiddenPotential.vue?vue&type=script&lang=js"
export * from "./hiddenPotential.vue?vue&type=script&lang=js"
import style0 from "./hiddenPotential.vue?vue&type=style&index=0&id=057b10d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b10d0",
  null
  
)

export default component.exports